import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { getOperatorList } from '../../helpers/Drop-down-options';

@Component({
  selector: 'app-my-ship-popup',
  templateUrl: './my-ship-popup.component.html',
  styleUrls: ['./my-ship-popup.component.scss']
})
export class MyShipPopupComponent {

  myshipForm: FormGroup;
  operatorlistOptions =[
    { label: 'SAKA - Satish', value: 'SAKA' },
    { label: 'SABA - Sandokan', value: 'SABA' },
    { label: 'ROAK - Roman', value: 'ROAK' },
    { label: 'AAHA - Ahmet', value: 'AAHA' },
    { label: 'NIAL - Nikita', value: 'NIAL' },
    // { label: 'JESH - Jeet', value: 'JESH' },
    { label: 'RAPA - Rahul', value: 'RAPA' },
    { label: 'AHKM - Abhishek', value: 'AHKM' },
    { label: 'SAMH - Sadique Muhammad', value: 'SAMH' },
    { label: 'ALYI - Alex', value: 'ALYI' },
    { label: 'KHGL - Khazar Guliyev', value: 'KHGL' } 
  ];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MyShipPopupComponent>
  ) {
    this.myshipForm = this.fb.group({
      eigerPic: [''],
    });
  }

  closeModal() {
    this.dialogRef.close();
  }
  
  submit() {
    const selectedOperator = this.myshipForm.get('eigerPic')?.value;    
    if (selectedOperator) {
      localStorage.setItem('selectedOperator', selectedOperator);
      this.dialogRef.close(selectedOperator);
      window.location.reload();
    } else {
      console.error('No operator selected');
    }
  }
  
}
